import {Component, OnInit, HostListener} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {ApiService} from '../../services/api/api.service';
import {FormatService} from '../../services/format/format.service';
import * as moment from "moment/moment";

declare const $: any;

@Component({
  selector: 'app-content-feed',
  templateUrl: './content-feed.component.html',
  styleUrls: ['./content-feed.component.css']
})
export class ContentFeedComponent implements OnInit {
  isForm: any;
  isData: any = [];
  isTotalAll: number = 0;
  isKeyword: string = '';

  isPage: number = 1;
  isPageSize: number = 10;
  isPages: any = [];
  isTableLoading: boolean = false;

  isLoading = false;
  attachment: any = null;
  isPreview: string = '';       // data-URL preview of a freshly chosen file
  isCurrentImage: string = '';  // stored photo shown while editing

  dataTeacher: any = [
    {'id': 1, 'text': 'Hatam Official'},
    {'id': 2, 'text': 'Ustadz Abdul Latif'},
    {'id': 3, 'text': 'Rohdian Al-Ahad'},
  ];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthenticationService,
    private apiService: ApiService,
    private formatService: FormatService,
  ) { }

  ngOnInit(): void {
    this.isPageSize = this.apiService.LIMIT || 10;
    this.resetForm();
    this.getData();
  }

  async resetForm() {
    this.attachment = null;
    this.isPreview = '';
    this.isCurrentImage = '';
    this.isForm = this.fb.group({
      id: new FormControl(''),
      teacher_id: new FormControl('', [Validators.required]),
      caption: new FormControl('', [Validators.required]),
      photos: new FormControl('', [Validators.required]),
    })
  }

  private searchTimer: any;
  private lastQuery: string = '';

  onKeywordInput(value: string) {
    this.isKeyword = value;
    clearTimeout(this.searchTimer);
    // debounce: wait 450ms after the last keystroke before hitting the API
    this.searchTimer = setTimeout(() => this.applyFilter(), 450);
  }

  async applyFilter() {
    clearTimeout(this.searchTimer);
    if (this.isKeyword === this.lastQuery) { return; } // query unchanged, skip the request
    this.lastQuery = this.isKeyword;
    this.isPage = 1;
    await this.getData();
  }

  async onReset() {
    this.isData = [];
    this.isPage = 1;
    this.isTotalAll = 0;
    this.isKeyword = '';
    this.lastQuery = '';
    await this.resetForm();
    await this.getData();
  }

  async getData() {
    let searchData = {"keyword": this.isKeyword};
    const offset = (this.isPage - 1) * this.isPageSize;
    this.isTableLoading = true;
    try {
      this.apiService.methodGetSilent(`teacher-feed/${offset}/${encodeURIComponent(JSON.stringify(searchData))}`, this.authService.getToken()).subscribe((response) => {
        this.isTableLoading = false;
        if (response && response.status == 200) {
          this.isData = [];
          (response.total ? response.data.forEach((element: any) => {
            // relations can be null — must never break the render
            element.teacherName = (element.teacher && element.teacher.user) ? element.teacher.user.name : '-';
            element.photoUrl = element.photo ? `${response.directoryFile}user/feed/${element.photo}` : '';
            element.createdVw = moment(element.createdAt).locale('id').format("D MMMM YYYY HH:mm");
            this.isData.push(element);
          }) : false);
          this.isTotalAll = response.total || 0;
          this.buildPager();
        }
      }, () => { this.isTableLoading = false; })
    } catch (error) {
      this.isTableLoading = false;
      console.log(error);
    }
  }

  totalPages() {
    return Math.max(1, Math.ceil(this.isTotalAll / this.isPageSize));
  }
  buildPager() {
    const total = this.totalPages();
    const pages: any[] = [];
    for (let p = 1; p <= total; p++) {
      if (p == 1 || p == total || Math.abs(p - this.isPage) <= 1) {
        pages.push(p);
      } else if (pages[pages.length - 1] != '...') {
        pages.push('...');
      }
    }
    this.isPages = pages;
  }
  async goToPage(p: any) {
    const total = this.totalPages();
    if (p < 1 || p > total || p == this.isPage) { return; }
    this.isPage = p;
    await this.getData();
  }
  rowNo(i: number) {
    return (this.isPage - 1) * this.isPageSize + i + 1;
  }
  summaryFrom() {
    return this.isTotalAll ? (this.isPage - 1) * this.isPageSize + 1 : 0;
  }
  summaryTo() {
    return (this.isPage - 1) * this.isPageSize + this.isData.length;
  }
  formatNumber(value: any) {
    return this.formatService.dotFormat(value || 0);
  }

  // wrap keyword matches in <mark> for the list; input is HTML-escaped first
  highlight(text: any) {
    const esc = String(text == null ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const keyword = this.isKeyword.trim();
    if (!keyword) { return esc; }
    const escapedKeyword = keyword
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // neutralize regex metacharacters
    return esc.replace(new RegExp(`(${escapedKeyword})`, 'gi'), '<mark class="vl-hl">$1</mark>');
  }

  // ===== delete confirmation (custom dialog, not SweetAlert) =====
  isConfirm: any = null; // {v}
  isDeleting: boolean = false;

  onDelete(v: any) {
    this.isConfirm = {v: v};
    document.body.style.overflow = 'hidden'; // lock the page scroll behind the dialog
    setTimeout(() => { // focus the Cancel button so the keyboard lands inside the dialog
      const btn: any = document.querySelector('.hds-dialog .vl-btn-ghost');
      if (btn) { btn.focus(); }
    });
  }

  closeConfirm() {
    if (this.isDeleting) { return; } // never close while a deletion is in flight
    this.isConfirm = null;
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  onEscapeConfirm() {
    if (this.isViewer) { this.closeViewer(); return; }
    if (this.isConfirm) { this.closeConfirm(); }
  }

  // reload without discarding filter/page; step back one page if this page becomes empty
  async refreshAfterMutation() {
    await this.getData();
    if (this.isData.length === 0 && this.isPage > 1) {
      this.isPage = this.isPage - 1;
      await this.getData();
    }
  }

  async confirmDelete() {
    const c = this.isConfirm;
    if (!c || this.isDeleting) { return; }
    this.isDeleting = true;
    this.apiService.methodDeleteSilent(`teacher-feed/${c.v.id}`, this.authService.getToken()).subscribe(async (response) => {
      this.isDeleting = false;
      if (response && response.status == 200) {
        this.closeConfirm();
        const caption = String(c.v.caption || '');
        await this.toastr.success(
          `${c.v.teacherName} — ${caption.length > 50 ? caption.slice(0, 50) + '…' : caption}`,
          `Feed dihapus`);
        this.refreshAfterMutation();
      } else {
        // failure: keep the dialog open so the user can retry
        await this.toastr.error((response && response.message) || `Coba lagi beberapa saat.`, `Gagal menghapus`);
      }
    }, async () => {
      this.isDeleting = false;
      await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menghapus`);
    });
  }

  // ===== form dialog =====
  async onShowAdd() {
    await this.resetForm();
    $('#formData').modal({backdrop: 'static', keyboard: false})
  }

  // show inline errors once a field is touched / after a submit attempt
  isInvalid(control: string) {
    const c = this.isForm.get(control);
    return c && c.invalid && (c.touched || c.dirty);
  }

  async onEdit(v: any) {
    try {
      await this.resetForm();
      await this.isForm.patchValue({id: v.id, teacher_id: v.teacher_id, caption: v.caption});
      this.isCurrentImage = v.photoUrl || '';
      // editing: a new photo is optional — the stored one stays if none is chosen
      this.isForm.controls['photos'].clearValidators();
      this.isForm.controls['photos'].updateValueAndValidity();
      // keyboard: false — Escape must never dismiss the dialog mid-save
      await $('#formData').modal({backdrop: 'static', keyboard: false, show: true});
    } catch (error) {
      console.log(error);
    }
  }

  async onFileSelect(e: any) {
    if (e.target.files.length > 0) {
      this.attachment = e.target.files[0];
      // preview the chosen file so the admin sees the photo before saving
      const reader = new FileReader();
      reader.onload = () => { this.isPreview = String(reader.result); };
      reader.readAsDataURL(this.attachment);
    }
  }

  async onSubmit() {
    try {
      if (this.isForm.invalid) {
        this.isForm.markAllAsTouched();
        return;
      }
      if (this.isLoading) { return; }
      this.isLoading = true;
      const payload = this.isForm.getRawValue();
      const isEdit = !!payload.id;
      let formValue = new FormData();
      formValue.append('id', payload.id);
      formValue.append('teacher_id', payload.teacher_id);
      formValue.append('caption', payload.caption);
      // the file lives in this.attachment — never in the form control (see playbook §8)
      if (this.attachment instanceof File) {
        formValue.append('photo', this.attachment);
      }
      const request = isEdit
        ? this.apiService.methodPutWithFormdata(`teacher-feed/${payload.id}`, formValue, this.authService.getToken())
        : this.apiService.methodPostWithFormdata(`teacher-feed`, formValue, this.authService.getToken());
      request.subscribe(async (response) => {
        this.isLoading = false;
        if (response && response.status == 200) {
          // close the modal only on success — on failure the user's input stays intact
          $('#formData').modal('hide');
          await this.toastr.success(`${this.teacherName(payload.teacher_id)}`, isEdit ? `Feed diupdate` : `Feed dibuat`);
          if (isEdit) {
            await this.refreshAfterMutation(); // keep the user's page & filter
          } else {
            await this.onReset(); // new item sits on page 1 (newest first)
          }
        } else {
          await this.toastr.error((response && response.message) || `Periksa isian lalu coba lagi.`, `Gagal menyimpan`);
        }
      }, async () => {
        this.isLoading = false;
        await this.toastr.error(`Periksa koneksi lalu coba lagi.`, `Gagal menyimpan`);
      });
    } catch (error) {
      this.isLoading = false;
      await this.toastr.error(`Periksa isian lalu coba lagi.`, `Gagal menyimpan`);
    }
  }

  teacherName(id: any) {
    const t = this.dataTeacher.find((d: any) => d.id == id);
    return t ? t.text : '';
  }

  // ===== full-size image viewer (lightbox) =====
  isViewer: string = '';

  openViewer(url: string) {
    if (!url) { return; }
    this.isViewer = url;
    document.body.style.overflow = 'hidden'; // lock the page scroll behind the viewer
  }

  closeViewer() {
    this.isViewer = '';
    document.body.style.overflow = this.isConfirm ? 'hidden' : '';
  }
}
